export const ONBOARDING_STEPS = [
  "set-name",
  "create-business",
  "business-profile",
  "integrations",
  "select-products",
] as const;

export type OnboardingStepKey = (typeof ONBOARDING_STEPS)[number];

/** Account + business creation — before the AI-assisted configuration. */
export const CORE_STEPS: OnboardingStepKey[] = ["set-name", "create-business"];

/**
 * Skippable configuration steps. Product selection is not skippable — it is
 * the finish line of onboarding (activation itself is sales-led).
 */
export const EXTENDED_STEPS: OnboardingStepKey[] = [
  "business-profile",
  "integrations",
];
